<script setup>

import {useRoute} from "vue-router";
import {storeToRefs} from "pinia/dist/pinia";
import {userUserNotificationStore} from "@/stores/userNotification.store";

const route = useRoute();
const userNotificationStore = userUserNotificationStore();
userNotificationStore.fetchOne(route.params.id);
const {userNotification} = storeToRefs(userNotificationStore);

</script>

<template>
  <van-cell-group inset>
    <van-cell>
      <template #title>
        <b>{{ userNotification.title }}</b>
      </template>
    </van-cell>
    <van-cell>
      <template #title>
        {{ userNotification.content }}
      </template>
    </van-cell>
    <van-cell v-if="userNotification.user_resourceable_type === 'session'" title="Session" is-link
              :to="'/session/' + userNotification.user_resourceable_id"/>
    <van-cell v-if="userNotification.user_resourceable_type === 'form'" title="Form" is-link
              :to="'/form/' + userNotification.user_resourceable_id"/>
    <van-cell v-if="userNotification.user_resourceable_type === 'exercise'" title="Exercise" is-link
              :to="'/exercise/' + userNotification.user_resourceable_id"/>
    <van-cell v-if="userNotification.user_resourceable_type === 'survey'" title="Survey" is-link
              :to="'/survey/' + userNotification.user_resourceable_id"/>
    <van-cell v-if="userNotification.user_resourceable_type === 'instruction'" title="Instruction" is-link
              :to="'/instruction/' + userNotification.user_resourceable_id"/>
    <van-cell v-if="userNotification.user_resourceable_type === 'file'" title="File" is-link :to="'/file/' + userNotification.user_resourceable_id"/>

    <van-cell title="From" :value="userNotification.created_by_user"/>
    <van-cell title="Created" :value="userNotification.created_at_formatted"/>
  </van-cell-group>
</template>
